// @ts-nocheck
export const BACKGROUND_ASSETS = {
  heroStudio: '/uploads/public/images/programming-background-with-person-working-with-codes-computer.jpg',
  developerPanel: '/uploads/public/images/developer-8829735_1280.jpg',
  webDevelopment: '/uploads/public/images/web-development.jpg',
  softwareCompany: '/uploads/public/images/Software-Development-Company.jpg',
  desktopWallpaper: '/uploads/public/images/Wallpapers/AngiSoft-Desktop-Wallpaper.png',
  /** BANNED: this asset is a 64px square-grid overlay, not a photograph.
   *  Do not use it as a section background. Kept only for reference. */
  landingWallpaper_GRID_DO_NOT_USE: '/uploads/public/images/Wallpapers/AngiSoft-Website-Landing-sr-Design.png',
  campaignBanner: '/uploads/public/images/Posters-Campaigns/AngiSoft-Campaign-Banner.png',
  thankYouPoster: '/uploads/public/images/Posters-Campaigns/AngiSoft-Thank-You.png',
  watermark: '/uploads/public/images/Branding/AngiSoft-Watermsrk.png',
  carBranding: '/uploads/public/images/Branding/AngiSoft-Car-Branding.png',
};

export const BACKGROUND_VARIANTS = {
  plain: {
    background: '#07142B',
  },
  paper: {
    background: '#F5F7FA',
    color: '#061324',
  },
  studio: {
    background: '#07142B',
    image: BACKGROUND_ASSETS.heroStudio,
    overlay: 'rgba(6, 19, 36, 0.78)',
    position: 'center',
  },
  services: {
    background: '#07142B',
    image: BACKGROUND_ASSETS.webDevelopment,
    overlay: 'rgba(6, 19, 36, 0.72)',
    position: 'center',
  },
  product: {
    background: '#07142B',
    image: BACKGROUND_ASSETS.developerPanel,
    overlay: 'rgba(6, 19, 36, 0.72)',
    position: 'center',
  },
  portfolio: {
    background: '#F5F7FA',
    color: '#061324',
  },
  resume: {
    background: '#F5F7FA',
    color: '#061324',
  },
  booking: {
    background: '#07142B',
    image: BACKGROUND_ASSETS.softwareCompany,
    overlay: 'rgba(6, 19, 36, 0.76)',
    position: 'center',
  },
  legal: {
    background: '#F5F7FA',
    color: '#061324',
  },
};
